export const WEB_GUIDE_PUBLISHED = 'web_guide_published';

// This track event type is triggered on guide creation, not state change
export const GUIDE_CREATED = 'guide-created';

export const GUIDE_STATE_CHANGED = 'guide-status-change';

export const GUIDE_EXPIRIMENT_STARTED = 'guide-experiment-started';

export const IDEA_TEST_PUBLISHED = 'idea-test-published';

export const EMBEDDED_POLL_GUIDE_PUBLISHED = 'embedded-poll-guide-published';

export const PUBLIC_GUIDE_CONTROLLED_ROLLOUT = 'public-guide-controlled-rollout';
